<button icon-button (click)="close()" class="close">
  <gl-icon [name]="'close-2'" class="close-icon"></gl-icon>
</button>
<div class="wrapper">
  <gl-icon name="notification-{{ type }}" class="icon"></gl-icon>
  <p class="text" [innerHTML]="text"></p>
</div>
